<template>
  <div class="tab_option" @mouseenter="showList" @mouseleave="hideList" :class="{on:show_option_list}">
      {{select.name}}
      <div class="option_list" v-show="show_option_list">
          <div class="option_bg">
              <ul class="option_list_two">
                  <li @mouseenter="showProvince(1)" @click="haddleSelectAddress('','全球')" :class="{on:select.demostic == ''}">全球</li>
                  <li @mouseenter="showProvince(1)" @click="haddleSelectAddress('0','国外')" :class="{on:select.demostic == '0'}">国外</li>
                  <li @mouseenter="showProvince(2)" @click="haddleSelectAddress('1','国内')" :class="{on:select.demostic == '1' && select.address_id == ''}">国内<Icon type="ios-arrow-forward"/></li>
              </ul>
              <ul class="option_list_thr" v-if="show_province">
                  <li
                      v-for="item,index in province"
                      @click="haddleSelectAddress('1',item.name,item.id)"
                      :key="index"
                      :class="{on:item.id == select.address_id}"
                      >{{item.name}}</li>
              </ul>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show_option_list: false,
      show_province: false,
      select: {
        name: '全球',
        demostic: '',
        address_id: ''
      }
    }
  },
  inject: ['page_title' ,'name', 'login', 'pageShowOrCancel', 'loginVipFlow'],
  computed: {
    address() {
      return this.$store.state.address
    },
    province() {
      let province = []
      this.address.map((a) => {
        if(a.pid == 2287){
          province.push(a)
        }
      })
      return province
    }
  },
  methods: {
    showProvince(type) {
      if(type == 2){
        this.show_province = true
      }else{
        this.show_province = false
      }
    },
    showList() {
      this.show_option_list = true
    },
    hideList() {
      this.show_option_list = false
      this.show_province = false
    },
    haddleSelectAddress(val,name,id) {
      this.loginVipFlow(() => {
        _czc.push(['_trackEvent', '投融资页面', this.page_title + '_' + this.name +'地域点击（'+ name +'）'])

        this.select.name = name
        this.select.demostic = val
        if(id){
          this.select.address_id = id
        }else{
          this.select.address_id = ''
        }
        this.$emit('selectAddress', this.select)
      })
      this.hideList()
    }
  },
  created() {}
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.tab_option
  position: relative
  font-size: 13px
  color: rgba(250, 122, 80, 1)
  cursor: pointer
  padding-right: 14px
  &:before
    content: ''
    position: absolute
    width: 8px
    height: 4px
    background: url('~pic/up_ico.png')
    background-size: 100%
    right: 0
    top: 5px
    transition_02s()
  &.on:before
    transform: rotate(180deg)
  .option_list
    position: absolute
    top: 14px
    padding: 6px 0
    z-index: 10
    left: 50%
    transform: translate(-60px, 0px)
    .option_bg
      .option_list_two
      .option_list_thr
        padding: 9px 0
        max-height: 168px
        overflow: auto
        commonBgColor(#2D2F34, #fff)
        commonShadow(0 4px 20px 0 rgba(0,0,0,0.50), 2px 4px 20px 0px rgba(121,133,143,0.2))
        li
          padding: 9px 12px
          font-size: 12px
          commonColor(#E9E9EB, #666666)
          cursor: pointer
          transition_02s()
          &.on
            color: rgba(250, 122, 80, 1)
          &:hover
            commonBgColor(#35383F, #f9f9f9)
        &::-webkit-scrollbar-track
          border: 0
          commonBgColor(#1F2330, #FFFFFF)
        &::-webkit-scrollbar
          width: 4px
          commonBgColor(#1F2330, #FFFFFF)
        &::-webkit-scrollbar-thumb
          commonBgColor(#4c4f59, #e8e8e8)
          border-radius: 2px
      .option_list_thr
        position: absolute
        left: 110px
        top: 6px
        width: 116px
        border-left: 2px solid
        commonBorderColor(#464952, #e8eaec)
      .option_list_two
        width: 110px
        overflow: auto
        li
          position: relative
          padding: 9px 30px 9px 12px;
          i
            font-size: 12px
            position: absolute
            right: 8px
            top: 9px
            commonColor(rgba(255,255,255,0.30), #CCCCCC)
</style>
